import React from "react";
import { Fade, Paper, Popper, Typography } from "@mui/material";

const PopperMessage = ({ placement, open, anchorEl, message }) => {
  return (
    <Popper open={open} anchorEl={anchorEl} placement={placement} transition style={{ maxWidth: "400px" }}>
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper>
            <Typography sx={{ p: 2 }}>{message}</Typography>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default PopperMessage;
